import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

    selectedPage = 20;
    totalPages = [];
    length = 0;

    @Input() collectionSize;
    @Input() page;
    @Input() pageSize;
    @Input() start;
    @Input() end;
    constructor() { }

    ngOnInit(): void {
        this.totalPages = [];
        this.length = Math.ceil(this.collectionSize/this.pageSize);
        for (let i=1; i<=this.length; i++) {
            this.totalPages.push(i);
        }
    }

    @Output() pageChange = new EventEmitter<string>();
    @Output() pageSelect = new EventEmitter<string>();

    prevPage() {
        const page = this.page - 1;
        if (page >= 1 && page <= this.length) {
            this.pageChange.next(page.toString());
        }
    }
    nextPage() {
        const page = this.page + 1;
        if (page >= 1 && page <= this.length) {
            this.pageChange.next(page.toString());
        }
    }

    changePage(pageOfItems) {
        if (parseInt(pageOfItems)!==parseInt(this.page) && pageOfItems >= 1 && pageOfItems <= this.length) {
            this.pageChange.next(pageOfItems);
        }
    }

    selectPage(pageSize: any) {
        this.selectedPage = pageSize;
        this.pageSelect.next(pageSize);

        this.totalPages = [];
        this.length = Math.ceil(this.collectionSize/this.selectedPage);
        for (let i=1; i<=this.length; i++) {
            this.totalPages.push(i);
        }
    }
}
